import { render } from "./CartTotalsProductSubtotal.vue?vue&type=template&id=b913bbc8"
import script from "./CartTotalsProductSubtotal.vue?vue&type=script&lang=js"
export * from "./CartTotalsProductSubtotal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__